import React from 'react';
import { Route, Routes } from 'react-router-dom'
import { initI18n } from './i18n'
import Main from './routes/Main'
import NoMatch from './routes/NoMatch'
import { QueryClient, QueryClientProvider } from 'react-query'
import packageJson from '../package.json'
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient()

initI18n()

function App() {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/*" element={<Main />} />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </QueryClientProvider>
      <div className="text-xs absolute w-10 bottom-0 -right-3 scale-75">{packageJson.version}</div>
      <ToastContainer
        position="top-right"
        autoClose={20000}
        hideProgressBar={true}
        transition={Slide}
        theme="light"
      />
    </>
  );
}

export default App;
